var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourcesNotification = function SvgResourcesNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M16 12h18v4H16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    fillRule: "evenodd",
    d: "M35.124 44H12c-2.412 0-6-1.598-6-6V10c0-4.402 3.588-6 6-6h26c2.206 0 4 1.794 4 4v21.582a8 8 0 0 0-4-.52V8H12c-.9.024-2 .39-2 2v22h22.755a7.96 7.96 0 0 0-1.693 4H12.024c-.924.024-2.024.39-2.024 2s1.1 1.976 2.024 2h19.557a8.03 8.03 0 0 0 3.543 4",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 37,
    r: 5,
    fill: "#EDBE62"
  })));
};
export { SvgResourcesNotification as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDEySDM0VjE2SDE2VjEyWiIgZmlsbD0iIzkwOUE5RiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM1LjEyNCA0NEgxMkM5LjU4OCA0NCA2IDQyLjQwMiA2IDM4VjEwQzYgNS41OTggOS41ODggNCAxMiA0SDM4QzQwLjIwNiA0IDQyIDUuNzk0IDQyIDhWMjkuNTgxNUM0MS4wNzM2IDI5LjIwNjUgNDAuMDYwOSAyOSAzOSAyOUMzOC42NjEzIDI5IDM4LjMyNzYgMjkuMDIxIDM4IDI5LjA2MTlWOEgxMkMxMS4xIDguMDI0IDEwIDguMzkgMTAgMTBWMTZWMzJIMzIuNzU0NkMzMS44NTMzIDMzLjEyNDQgMzEuMjQ5MyAzNC40OTc1IDMxLjA2MTkgMzZIMTIuMDI0QzExLjEgMzYuMDI0IDEwIDM2LjM5IDEwIDM4QzEwIDM5LjYxIDExLjEgMzkuOTc2IDEyLjAyNCA0MEgzMS41ODE1QzMyLjI3MTIgNDEuNzAzOCAzMy41MzA4IDQzLjExNiAzNS4xMjQgNDRaIiBmaWxsPSIjOTA5QTlGIi8+CjxjaXJjbGUgY3g9IjM5IiBjeT0iMzciIHI9IjUiIGZpbGw9IiNFREJFNjIiLz4KPC9zdmc+Cg==";